module.exports = __webpack_public_path__ + "img/ring_r_s_1_0@3x.185e55fd.png";